import React, { useEffect } from 'react';
import { Badge, InputProps, Tooltip } from 'antd';
import { FormikErrors } from 'formik';
import { withTheme, ThemeProps, DefaultTheme } from 'styled-components';
import { StyledInput, Title, Container, BadgeContainer } from './styles';

export interface IProps extends InputProps, ThemeProps<DefaultTheme> {
    error?: string | string[];
    label?: string;
    arrayValue?: string[];
    setFieldValue: (
        field: string,
        value: string | string[],
        shouldValidate?: boolean | undefined,
    ) => Promise<FormikErrors<any>> | Promise<void>;
}

const BarCodeInput: React.FC<IProps> = ({
    error,
    label,
    name,
    value,
    setFieldValue,
    theme,
    arrayValue,
    ...rest
}) => {
    const [barCodes, setBarCodes] = React.useState<string[]>([]);

    useEffect(() => {
        handleBadges();
    }, []);

    useEffect(() => {
        handleValue(barCodes);
    }, [barCodes]);

    useEffect(() => {
        handlePrevBadges();
    }, [arrayValue]);

    const handleValue = (badges: string[]) => {
        setFieldValue(`${name}Arr`, badges);
    };

    const handleBadges = () => {
        // to chomp and trim strings/arrayfy the string set
        const newValue = value
            ?.toString()
            .split(',')
            .map((code) => code.replace(' ', ''));

        // to remove duplicate entries
        if (newValue !== undefined) {
            const sanitizedValue = [...barCodes, ...newValue].filter(
                (elem, index, self) => {
                    return index === self.indexOf(elem) && elem !== '';
                },
            );

            setBarCodes(sanitizedValue);
        }

        setFieldValue(name || '', '');
    };

    const handlePrevBadges = () => {
        if (arrayValue) {
            setBarCodes(arrayValue);
        }
    };

    const removeBadges = (codeToRemove: string) => {
        const badges = barCodes;
        const newBades = badges.filter((code) => code !== codeToRemove);
        setBarCodes(newBades);
    };

    return (
        <Container>
            <Tooltip placement="topLeft" title={error ?? null}>
                <Title>{label}</Title>
                <StyledInput
                    error={error}
                    name={name}
                    id={name}
                    value={value}
                    {...rest}
                    onBlur={handleBadges}
                />
            </Tooltip>
            <BadgeContainer>
                {barCodes.map((code, index) => {
                    return (
                        <Tooltip key={index} placement="topLeft" title={code}>
                            <span onClick={() => removeBadges(code)}>
                                <Badge
                                    style={{
                                        backgroundColor: `${
                                            index === 0
                                                ? theme.colors.accentColor
                                                : 'gray'
                                        }`,
                                        userSelect: 'none',
                                    }}
                                    key={index}
                                    count={code}
                                    // Todo: set a max value
                                    overflowCount={99999999999999}
                                />
                            </span>
                        </Tooltip>
                    );
                })}
            </BadgeContainer>
        </Container>
    );
};

export default withTheme(BarCodeInput);
